import { yupResolver } from '@hookform/resolvers/yup';
import React, { useContext, useRef, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { MoonLoader } from 'react-spinners';
import styled from 'styled-components';
import * as Yup from 'yup';
import { PromiseLoader, Input } from "react-builder";
import { AuthContext } from "react-builder";
import { Attribute, AttributeGroup, AttributeProperty, ComponentProps } from "react-builder";
import { ProductServerAuthContext } from '../providers/ProductServerAuth';

interface ISignupFormData {
  email: string,
  password: string,
  confirm: string,
  cb: boolean
}

@AttributeGroup({
  blockName: "SignupForm",
  title: "Signup form",
  icon: "<div></div>"
})
export class SignupFormAttributes extends Attribute {
  @AttributeProperty({ type: 'String' })
  emailLabel: string = 'Email';
  @AttributeProperty({ type: 'String' })
  passwordLabel: string = 'Password';
  @AttributeProperty({ type: 'String' })
  confirmPasswordLabel: string = 'Confirm';
  // @AttributeProperty({ type: 'String' })
  // redirectUrl: string = '';
  @AttributeProperty({ type: 'String' })
  buttonText: string = 'Start 5 days trial';
}

export const SignupFormTheme = styled.div((props: { attributes: SignupFormAttributes }) => `

  & {
    .term-wrap label {
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        align-items: start;

        p{
          margin: 0;
        }
    }

    .term-wrap{
      padding-bottom: 20px;
    }

    input {
        display: block;
    }

    input[type="checkbox"] {
        margin: 1px 5px 0 0;
    }

      
  }

  & form button,
  .signin form button,
  #support form button {
      width: 100%;
  }

  form .input-error {
      margin: 0;
      padding: 0;
      font-size: 12px;
      font-weight: 400;
      color: #cc0700;
  }


`);

function SignupForm(props: ComponentProps<SignupFormAttributes>) {

  const { isLoggedIn, isLoginDialogOpen, setLoginDialogOpen, signup, signupError } = useContext(AuthContext)!;
  const authV2 = useContext(ProductServerAuthContext);

  const formSchema = Yup.object().shape({
    email: Yup.string()
      .required('Email is required')
      .matches(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/, "Valid email address reuiqred"),
    password: Yup.string()
      .required('Password is mandatory')
      .min(3, 'Password must be at 3 char long'),
    confirm: Yup.string()
      .required('Password is mandatory')
      .oneOf([Yup.ref('password')], 'Passwords does not match'),
    cb: Yup.boolean().oneOf([true], 'Required')
  })
  const formOptions = { resolver: yupResolver(formSchema) }
  const { register, watch, formState, handleSubmit } = useForm<ISignupFormData>(formOptions);
  const password = watch("password");

  const [signupPromise, setSignupPromise] = useState<Promise<any> | undefined>(undefined);

  const onSubmit: SubmitHandler<ISignupFormData> = (data: ISignupFormData) => {
    console.log(data, formState.errors.email);
    if (authV2?.signup) {
      setSignupPromise(authV2.signup(data.email, data.password).then((success: any) => {

        return success;
      }))
    } else {

      setSignupPromise(signup(data.email, data.password).then((success: any) => {

        return success;
      }))
    }
  }

  React.useEffect(() => {

  }, [watch]);

  const passInput = useRef<HTMLInputElement>();

  return (
    <SignupFormTheme {...props} >
      <PromiseLoader
        promise={signupPromise}
        overlayColor={'rgba(247, 247, 247,.6)'}
        loader={<MoonLoader loading={true} size={60} />
        }
      >
        {res => <div className="form">
          <form onSubmit={handleSubmit(onSubmit)} noValidate>

            <Input name='email' type='email' label={props.attributes.emailLabel} register={register} error={formState.errors.email} />


            <Input ref={passInput} name='password' type='password' label={props.attributes.passwordLabel} register={register} error={formState.errors.password} />
            <Input name='confirm' type='password' label={props.attributes.confirmPasswordLabel} register={register} error={formState.errors.confirm} />

            <div className="term-wrap">
              <label htmlFor="check">
                <input {...register('cb')} type="checkbox" name="cb" />
                <div className="terms-text ng-binding">
                  {props.children}
                </div>
              </label>
              <p className='input-error'>{formState.errors.cb?.message}</p>
            </div>
            <button type="submit" >{props.attributes.buttonText}</button>
            <p className='input-error' >{authV2.signupError??signupError}</p>
            <div className="text-center links-wrap ng-scope" ng-controller="HeaderController as $ctrl">
              <p className="ng-binding">Existing users, <a onClick={(e) => (authV2.setLoginDialogOpen ?? setLoginDialogOpen)!(true)} >Log in</a></p>
            </div>
          </form>
        </div>}
      </PromiseLoader>
    </SignupFormTheme>
  );

};

SignupForm.prototype.Props = SignupFormAttributes;

export default SignupForm;